import * as tus from 'tus-js-client';
import { calculateProgress, emitUploadHasBeenStarted, errorInitialParse, finalize, getFileToUpload, getTusSettings } from './utils';
import { HttpClient } from '@wix/http-client';
import { UploadEvent } from '../../constants/upload-event';
import { UploadStatus } from '../../constants/upload-status';
export function initTusUploader(url, data, options, cancelAndProgressConfig, responseHandler, http) {
  const {
    file,
    upload_token,
    acl,
    parent_folder_id
  } = data;
  const params = {
    filename: file.name,
    acl,
    token: upload_token,
    parent_folder_id
  };
  const fileToUpload = getFileToUpload(file);
  const tusConfig = {};
  let isResumable = false;
  let isTryingToResume;
  let shouldTryToResume = false;
  let isInPatchRequest = false;
  const getShouldTryToResume = () => {
    return shouldTryToResume;
  };
  const setShouldTryToResume = isShouldTryToResume => {
    shouldTryToResume = isShouldTryToResume;
  };
  const getTusUploadInstance = () => {
    return tusConfig.tusUploadInstance;
  };
  const getIsResumable = () => {
    return isResumable;
  };
  const setIsResumable = newIsResumable => {
    isResumable = newIsResumable;
  };
  const resolveResumeTrying = tusUploadInstance => {
    if (isInPatchRequest) {
      tusUploadInstance.abort().then(() => {
        isTryingToResume = false;
        setShouldTryToResume(false);
        tusConfig.tryToResumeResolvePromise(true);
      });
    }
    isInPatchRequest = true;
  };
  const tusCallback = {
    onError: error => {
      if (isTryingToResume) {
        tusConfig.tryToResumeResolvePromise(false);
        setShouldTryToResume(true);
        isTryingToResume = false;
      } else {
        errorInitialParse(error, tusConfig, setIsResumable, setShouldTryToResume, isTryingToResume);
      }
    },
    onProgress: (bytesUploaded, bytesTotal) => {
      if (isTryingToResume) {
        resolveResumeTrying(tusConfig.tusUploadInstance);
      } else {
        calculateProgress(cancelAndProgressConfig, bytesUploaded, bytesTotal);
      }
    },
    onSuccess: () => {
      cancelAndProgressConfig.progressEventEmitter.emit(UploadEvent.Upload, {
        status: UploadStatus.Processing,
        total: 100,
        loaded: 100
      });
      tusConfig.uploadPromiseResolve();
    }
  };
  const tusOptions = {
    ...getTusSettings(url, params, options),
    ...tusCallback
  };
  tusConfig.tusUploadInstance = new tus.Upload(fileToUpload, tusOptions);
  const getNewUploadPromise = () => {
    return new Promise((resolve, reject) => {
      tusConfig.uploadPromiseResolve = resolve;
      tusConfig.uploadPromiseReject = reject;
    }).then(() => finalize(http, url, upload_token, params)).catch(error => {
      return Promise.reject(error);
    });
  };
  const upload = () => {
    setShouldTryToResume(false);
    emitUploadHasBeenStarted(cancelAndProgressConfig);
    tusConfig.tusUploadInstance.start();
    return getNewUploadPromise();
  };
  const tryToResume = () => {
    isInPatchRequest = false;
    isTryingToResume = true;
    setShouldTryToResume(false);
    tusConfig.tusUploadInstance.start();
    return new Promise(resolve => {
      tusConfig.tryToResumeResolvePromise = resolve;
    });
  };
  const resume = () => {
    setShouldTryToResume(false);
    setIsResumable(false);
    tusConfig.tusUploadInstance.start();
    return getNewUploadPromise().then(responseHandler);
  };
  const abort = () => {
    const httpClient = new HttpClient();
    const source = httpClient.CancelToken.source();
    tusConfig.tusUploadInstance.abort().then(() => {
      setIsResumable(true);
      source.cancel('aborted by user');
      tusConfig.uploadPromiseReject(source.token.reason);
    });
  };
  return {
    upload,
    resume,
    tryToResume,
    abort,
    getTusUploadInstance,
    getIsResumable,
    getShouldTryToResume
  };
}